import { REGROUPEMENT } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT, CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import { getAffectationProduitReseauTempo } from '@/api/affectation/index';

export async function getAffectionOfProductTempo(lignesCommande) {
  const listAffectationAllProduit = [];
  const lignesTempo = lignesCommande
    .filter((ligne) => {
      return ligne.type === REGROUPEMENT
      && ligne.typeProduit === CATEGORIE_REGROUPEMENT
      && ligne.lignesCommande
      && ligne.lignesCommande.some(l => {
        return l.typeProduit === CATEGORIE_LOCATION;
      });
    });
  if (!lignesTempo) return [];
  lignesTempo.forEach((ligneRegroupement) => {
    const produitDejaPresent = listAffectationAllProduit
      .find((affectation) => { return affectation.id === ligneRegroupement.produitId; });
    if (produitDejaPresent !== undefined) {
      produitDejaPresent.anneeSemaines.push(ligneRegroupement.ligneReseau.anneeSemaine);
      return;
    }
    listAffectationAllProduit.push({
      id: ligneRegroupement.produitId,
      anneeSemaines: [ligneRegroupement.ligneReseau.anneeSemaine],
    });
  });

  if (listAffectationAllProduit.length === 0) return [];

  const affectationOfProduit = (await getAffectationProduitReseauTempo(
    listAffectationAllProduit, true,
  )).data.result;
  return affectationOfProduit;
}

export function updateAffectationProduitReseauTempo(ligne, affectationOfLigne) {
  ligne.affectation = affectationOfLigne.filter((affectation) => {
    return affectation.anneSemaine === ligne.ligneReseau.anneeSemaine;
  });
}

export async function updateAffectationProduitTempoFromDevis(devisCommande) {
  const affectationList = await getAffectionOfProductTempo(devisCommande.lignesCommande);
  devisCommande.lignesCommande.forEach((ligne) => {
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT
      && ligne.type === REGROUPEMENT
      && ligne.lignesCommande
      && ligne.lignesCommande.some(l => {
        return l.typeProduit === CATEGORIE_LOCATION;
      })
    ) {
      updateAffectationProduitReseauTempo(ligne, affectationList[ligne.produitId]);
    }
  });
}
